module.exports = __webpack_public_path__ + "5f4e16e9ef6aa18c55fa50faf4810577.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgdab_h.png
// module id = 279
// module chunks = 3